import { PhoneFilled } from "@ant-design/icons";
import { Modal, Button, message, Result, Skeleton, Tooltip } from "antd";
import axios from "axios";
import "./style.scss";
import { useDispatch, useSelector } from "react-redux";
import ReusableTable from "../../Reuseable/ReusableTable/ReusableTable";
import { useEffect, useState } from "react";
import { fetchTelecallerFeedbackCases } from "../../store/telecaller/cases";
import { formatCurrency } from "../../assets/helpers";

const ActionCodesModal = ({ open = false, setOpen, data }) => {
  const { token } = useSelector((state) => state.auth);
  const { format } = useSelector((state) => state.priceFormat);

  const { feedback_cases, feedback_cases_loading } = useSelector(
    (state) => state?.telecallerCases,
  );
  const dispatch = useDispatch();
  const [pagination, setPagination] = useState({ page: 1, page_size: 10 });

  useEffect(() => {
    if (open) {
      setPagination({ page: 1, page_size: 10 });
      dispatch(
        fetchTelecallerFeedbackCases({
          disposition: [data?.filter_key],
          page: 1,
          page_size: 10,
        }),
      );
    }
  }, [open, data, dispatch]);

  const handleTableChange = (page, size) => {
    setPagination({ page, page_size: size });
    dispatch(
      fetchTelecallerFeedbackCases({
        disposition: [data?.filter_key],
        page,
        page_size: size,
      }),
    );
  };

  const columns = [
    {
      title: "Customer Name",
      dataIndex: "customer_name",
      key: "customer_name",
      render: (text) =>
        feedback_cases_loading ? (
          <Skeleton.Input size="small" active />
        ) : (
          text || "-"
        ),
    },
    {
      title: "Loan No.",
      dataIndex: "loan_no",
      key: "loan_no",
      render: (text) =>
        feedback_cases_loading ? (
          <Skeleton.Input size="small" active />
        ) : (
          text || "-"
        ),
    },
    {
      title: "Phone Number",
      dataIndex: "phone_number",
      key: "phone_number",
      render: (text) =>
        feedback_cases_loading ? (
          <Skeleton.Input size="small" active />
        ) : (
          text || "-"
        ),
    },
    {
      title: "POS",
      dataIndex: "odpos",
      key: "odpos",
      render: (text) =>
        feedback_cases_loading ? (
          <Skeleton.Input size="small" active />
        ) : (
          Number(text).toFixed(2) || "-"
        ),
    },

    {
      title: "Amount Overdue",
      dataIndex: "amount_overdue",
      key: "amount_overdue",
      render: (text) =>
        feedback_cases_loading ? (
          <Skeleton.Input size="small" active />
        ) : (
          formatCurrency(text, format) || "-"
        ),
    },
    {
      title: "Bank",
      dataIndex: "bank_name",
      key: "bank_name",
      render: (text) =>
        feedback_cases_loading ? (
          <Skeleton.Input size="small" active />
        ) : (
          text || "-"
        ),
    },

    {
      title: "Feedback Date",
      dataIndex: "date",
      key: "date",
      render: (text) =>
        feedback_cases_loading ? (
          <Skeleton.Input size="small" active />
        ) : (
          text || "-"
        ),
    },
    {
      title: "Disposition",
      dataIndex: "call_status",
      key: "call_status",
      render: (text) =>
        feedback_cases_loading ? (
          <Skeleton.Input size="small" active />
        ) : (
          text || "-"
        ),
    },

    {
      title: "Comment",
      dataIndex: "comment",
      key: "comment",
      render: (text) =>
        feedback_cases_loading ? (
          <Skeleton.Input size="small" active />
        ) : text?.length > 20 ? (
          <Tooltip title={text}>{text?.slice(0, 20) + "..."}</Tooltip>
        ) : (
          text || "-"
        ),
    },
  ];

  return (
    <Modal
      footer={false}
      title="Action Codes Coverage"
      open={open}
      onCancel={() => setOpen(false)}
      className="action-codes-modal"
      // style={{ width: '100%' }}
    >
      <ReusableTable
        columns={columns}
        dataSource={
          feedback_cases_loading
            ? Array(5).fill({})
            : feedback_cases?.results?.cases_with_feedback || []
        }
        totalItems={feedback_cases?.count || 0}
        CurrentPageNo={pagination.page}
        pageSize={pagination.page_size}
        triggerChange={handleTableChange}
      />
    </Modal>
  );
};

export default ActionCodesModal;
